export default __webpack_public_path__ + "static/media/Ideate_6.1975c7da.jpg";